import axios from 'axios';

import {
  REQ_S3_URL_START, REQ_S3_URL_FAILED,
  S3_UPLOAD_SUCCESS, S3_UPLOAD_FAILED,
} from './types';
import {PGEN_S3URL} from './paths';
import {UROOT_API, GENERIC_HEADER} from './api_const';

export const uploadPicToS3 = ({img, callback}) => {
  const headers = Object.assign({}, GENERIC_HEADER);

  const fname = img.name;
  const fsize = img.size;
  // console.log('can i do this??', fname, fsize);

  return (dispatch) => {
    dispatch({type: REQ_S3_URL_START});
    // NOTE FIRST get signed AWS S3 url
    axios.post(UROOT_API+PGEN_S3URL, {fname, fsize}, {headers})
      .then(resp => {
        console.log('s3 signed url', resp.data.url);
        uploadUserPicToS3(dispatch, img, resp.data.url, callback);
      })
      .catch(error => {
        window.confirm('Cannot upload pic to our servers, please try again or contact support@pollpals.com');
        console.log('gen S3 url ERROR: ', error);
        dispatch({type: REQ_S3_URL_FAILED, error});
      });
  };
}

const uploadUserPicToS3 = (dispatch, img, s3_url, callback) => {
  const uploadOptions = {
    headers: {
      'Content-Type': 'image/jpeg, image/png',
      'ContentLength': img.size
    }
  };
  axios.put(s3_url, img, uploadOptions)
    .then(resp => {
      console.log('IMAGE UPLOADED!! ', resp);
      dispatch({
        type: S3_UPLOAD_SUCCESS,
        payload: `https://s3.us-east-2.amazonaws.com/pollpals-poll-imgs/${img.name}`,
      });
      callback();
    })
    .catch(error => {
      window.confirm('Cannot upload img to our servers, please try again or contact support@pollpals.com');
      console.log('uploading prof pic to S3 ERROR: ', error);
      dispatch({type: S3_UPLOAD_FAILED, error})
    });
}



// WEBPACK FOOTER //
// ./src/actions/aws_actions.js